import React from "react";
import { OptionsSearchType } from "@/types/OptionType";
import { useRouter } from "next/router";
import { getRelativePathFromLink, optimizeURL } from "@/utils/url";
import { useSearch } from "./useSearch";
import { Section } from "../Global/Section/Section";
import styles from "./SearchResult.module.scss";
import { SearchTab } from "./SearchTab/SearchTab";
import { Headline } from "../Global/Headline/Headline";
interface SearchResultProps {
  searchOptions: OptionsSearchType;
  bgColor: string;
}

export const SearchResult = ({ searchOptions }: SearchResultProps) => {
  const { currentTab, setCurrentTab, tabs, fetchMore, searchKeyword } =
    useSearch();
  const { search_page_link, search_results, search_headline } =
    searchOptions ?? {};
  const router = useRouter();
  //#region return null if no search page link is provided
  const activePath = router.asPath.match(/^([^?]+)/) || [];
  const search_page_link_path = search_page_link
    ? optimizeURL(search_page_link)
    : null;
  const link =
    search_page_link_path && getRelativePathFromLink(search_page_link_path);
  const isSearchPage = activePath[1] === link;

  if (!isSearchPage) return null;
  //#endregion
  const activeTab = tabs[0];

  return (
    <Section
      columnsClassName="is-multiline is-centered"
      className={styles["search"]}
    >
      <div className="column is-10-tablet is-8-widescreen has-text-centered">
        <Headline
          subline={`${search_headline} “${searchKeyword}”`}
          headline={`${activeTab.totalResults} ${search_results}`}
          headline_html_tag="h2"
        />
      </div>
      <SearchTab
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        tabsData={tabs}
        fetchMore={fetchMore}
      />
    </Section>
  );
};
